// consultation flyout, modal, and native submission handler
window.addEventListener('DOMContentLoaded', () => {
  console.log('>>> consultations.js loaded');

  const wrapper = document.querySelector('.js-consultation-wrapper');
  const closeBtn = document.querySelector('.js-consultation-close');
  const avatar = document.querySelector('.js-consultation-toggle');
  
  // Overlay references
  const overlay = document.getElementById('custom-consultation-overlay');
  const triggerBtn = wrapper?.querySelector('.js-consultation-trigger, #open-callback-form');
  const overlayCloseBtn = overlay?.querySelector('.close-modal');

  const form = document.getElementById('consultation-callback-form');
  const formSubmitted = sessionStorage.getItem('consultation_submitted');

  // If we just submitted, keep the flyout open and show success state instantly on reload
  if (formSubmitted && form) {
    sessionStorage.removeItem('consultation_submitted');
    if (wrapper) wrapper.classList.add('is-open');
    form.innerHTML = `
      <div class="form-success-message" style="padding: 30px 20px; text-align: center;">
        <p style="font-weight: 600; font-size: 16px; color: #333; margin: 0;">Thank you! The Groomed Goddess will reach out to you shortly.</p>
      </div>
    `;
  }

  if (wrapper && closeBtn && avatar) {
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    let isClosedManually = false;

    const closeFlyout = () => {
      wrapper.classList.remove('is-open');
      isClosedManually = false;
      closeBtn.blur();
    };

    if (!isTouchDevice) {
      wrapper.addEventListener('mouseenter', () => {
        if (!isClosedManually) wrapper.classList.add('is-open');
      });
      wrapper.addEventListener('mouseleave', () => {
        isClosedManually = false;
      });
    }

    avatar.addEventListener('click', (e) => {
      e.stopPropagation();
      if (wrapper.classList.contains('is-open')) {
        isClosedManually = true;
        wrapper.classList.remove('is-open');
      } else {
        isClosedManually = false;
        wrapper.classList.add('is-open');
      }
    });

    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      isClosedManually = true;
      closeFlyout();
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) closeFlyout();
    });

    if (triggerBtn && overlay) {
      triggerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeFlyout();
        overlay.classList.add('is-open');
      });
    }

    if (overlayCloseBtn && overlay) {
      overlayCloseBtn.addEventListener('click', () => {
        overlay.classList.remove('is-open');
      });
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) overlay.classList.remove('is-open');
      });
    }
  }

  // --- Native Submission with Session State Persistence ---
  document.addEventListener('submit', function (e) {
    const targetForm = e.target;
    
    if (targetForm && targetForm.id === 'consultation-callback-form') {
      console.log('>>> NATIVE SUBMIT TRIGGERED');
      
      // Set session flag so reload displays the success message right away
      sessionStorage.setItem('consultation_submitted', 'true');
      
      // Let the browser submit natively to Shopify's /contact endpoint
      return true;
    }
  }, true);
});